<template>
	<section v-if="isExportEmailModalOpen" class="exportEmailContainer">
		<loading :active.sync="isLoading" :is-full-page="false" />
		<div class="overlay" @click="closeEmailInputModal" />
		<main class="mainContent">
			<div class="exportEmailHeader">
				<div class="buttonContainer">
					<h3 class="exportEmailTitle">
						Export Preview
					</h3>
					<button class="cancelButton" @click="closeEmailInputModal">
						Cancel
					</button>
				</div>
			</div>
			<form class="exportEamilForm">
				<div class="block">
					<span class="textCell">From</span>
					<span class="selectedItem">{{ userSelectedStartDate }}</span>
				</div>
				<div class="block">
					<span class="textCell">To</span>
					<span class="selectedItem">{{ userSelectedEndDate }}</span>
				</div>
				<div class="block">
					<span class="textCell">Category</span>
					<span class="selectedItem">{{ userChoiceOfCategoryName }}</span>
				</div>
				<div class="block">
					<span class="textCell">Project</span>
					<span class="selectedItem">{{ userChoiceOfProjectName }}</span>
				</div>
				<div class="block">
					<span class="textCell">Reimbursable</span>
					<span class="selectedItem">
						<label class="switch">
							<input
								type="checkbox"
								:checked="reimbursable"
								readonly
								disabled
							/>
							<span class="slider round" />
						</label>
					</span>
				</div>
				<div class="block">
					<span class="textCell">Attach Receipts</span>
					<span class="selectedItem">
						<label class="switch">
							<input
								type="checkbox"
								:checked="attachReceipts"
								readonly
								disabled
							/>
							<span class="slider round" />
						</label>
					</span>
				</div>
				<section class="emailArea">
					<label>Email</label>
					<div class="block" type="button">
						<span class="textCell">To</span>
						<input
							id="emailToSend"
							type="email"
							required
							class="emailInput"
							@focus="event => $emit('validateUserEmail', event)"
							@input="event => $emit('validateUserEmail', event)"
							@blur="userEmailInputBlur"
						/>
					</div>
					<div v-if="userEmailErrorMessage" class="error">
						<div class="input placeholder">
							{{ userEmailErrorMessage }}
						</div>
					</div>
					<div class="block" type="button">
						<span class="textCell">CC</span>
						<input
							type="email"
							placeholder="Optional"
							class="emailInput"
							@focus="event => $emit('validateCcEmail', event)"
							@input="event => $emit('validateCcEmail', event)"
							@blur="ccEmailInputBlur"
						/>
					</div>
					<div v-if="ccEmailErrorMessage" class="error">
						<div class="input placeholder">
							{{ ccEmailErrorMessage }}
						</div>
					</div>
				</section>
				<div class="actionButtonsContainer">
					<small>
						You will receive an email with <br />
						CSV file attached in few minutes
					</small>
					<button
						type="submit"
						class="nextButton"
						@click="handleSubmit($event)"
					>
						Submit to Export
					</button>
				</div>
			</form>
		</main>
	</section>
</template>

<script>
import Loading from "vue-loading-overlay";

export default {
	components: {
		Loading
	},
	props: [
		"isExportEmailModalOpen",
		"closeEmailInputModal",
		"userSelectedStartDate",
		"userSelectedEndDate",
		"userChoiceOfCategoryName",
		"userChoiceOfProjectName",
		"attachReceipts",
		"reimbursable",
		"userEmail",
		"validateUserEmail",
		"userEmailInputBlur",
		"userEmailErrorMessage",
		"ccEmail",
		"validateCcEmail",
		"ccEmailInputBlur",
		"ccEmailErrorMessage",
		"handleSubmit",
		"isLoading"
	]
};
</script>
